import { render, staticRenderFns } from "./viewNotaFiscal.vue?vue&type=template&id=c0512f04&scoped=true&"
import script from "./viewNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./viewNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./viewNotaFiscal.vue?vue&type=style&index=0&id=c0512f04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0512f04",
  null
  
)

export default component.exports